/* This is a simple representation of the three.js Vector2 class */
import { Vec2Input } from '@src/app/generated/globalTypes';
import { GetAllMaterials_allMaterials_edges_node_normalScale } from '@src/app/generated/GetAllMaterials';
import { Vector2 } from 'three';

export class PortalVector2 extends Vector2 {
  constructor(x?: number, y?: number) {
    super(x, y);
  };

  static fromGql(gql: GetAllMaterials_allMaterials_edges_node_normalScale): PortalVector2 {
    return new PortalVector2(
      gql.x,
      gql.y
    );
  }

  static fromThree(input: Vector2): PortalVector2 {
    if (input && input['x'] !== undefined && input['y'] !== undefined) {
      return new PortalVector2(
        input.x,
        input.y
      );
    } else {
      return new PortalVector2(0, 0);
    }
  }

  toGqlInput(): Vec2Input {
    return {
      x: this.x ?? 0,
      y: this.y ?? 0,
    };
  }
}
